module.exports = __webpack_public_path__ + "img/PPMPprint5.d29557f7.png";